<template>
  <div class="tm-faq-header">
    <slot name="title">
      <h2 class="tm-faq-header__title">
        {{ title }}
      </h2>
    </slot>
    <slot name="description">
      <div
        v-if="description"
        class="tm-faq-header__description"
      >
        {{ description }}
      </div>
      <div
        v-else
        class="tm-faq-header__description"
      >
        <tm-translate keypath="faq.description">
          <template v-slot:contact>
            <support-link :text="$t('common.contactUs')" />
          </template>
        </tm-translate>
      </div>
    </slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@/composition/vue/compositionApi'
import TmTranslate from '@/components/TmTranslate.vue'
import SupportLink from '@/components/shared/SupportLink.vue'

export default defineComponent({
  components: {
    SupportLink,
    TmTranslate,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
    },
  },
})
</script>

<style lang="scss" scoped>
.tm-faq-header {
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 24px;
  &__title {
    margin-bottom: 8px;
    font-size: $xl-font;
    line-height: 30px;
    text-align: center;
  }
  &__description {
    text-align: center;
    font-size: $md-font;
    color: $neutral;
    line-height: 20px;
  }
}
</style>
